import { ComboboxItem, Select, SelectProps } from '@mantine/core';
import { useGetBonusPeriods } from 'api-hooks/bonus';
import React from 'react';
interface BonusPeriodSelectProps extends SelectProps {}

export default function BonusPeriodSelect(props: BonusPeriodSelectProps) {
  const query = useGetBonusPeriods({
    params: {
      limit: -1,
    },
  });

  const data: ComboboxItem[] = (query.data?.data || []).map((v) => ({
    value: v.id,
    label: v.name,
  }));
  return (
    <Select
      {...props}
      data={data}
      disabled={query.isLoading || props.disabled}
    />
  );
}
